import * as React from 'react';
import { DefaultThemed } from '../ThemeProvider/ThemeProvider';
import { StyledButton, StyledLoaderWrapper } from './Button.styled';
import { ButtonProps, ButtonVariantsEnum } from './Button.types';
import { ReactComponent as Loader } from '../assets/svg/loader.svg';

export const Button: React.FC<ButtonProps> = ({
  typeStyle,
  size,
  children,
  disabled,
  onClick,
  sticky,
  noMinWidth,
  loader,
  loaderDesc,
  isFocused,
  ...restProps
}: ButtonProps) => {
  const [clickPosition, setClickPosition] = React.useState({
    left: '0',
    top: '0',
    diameter: 1,
  });

  const manageClickRippleParams = (event): void => {
    const button: HTMLElement = event.currentTarget;
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    const left = `${event.clientX - button.offsetLeft - radius}px`;
    const top = `${event.clientY - button.offsetTop - radius}px`;

    setClickPosition({ left, top, diameter });
  };

  const handleClick = (event): void => {
    manageClickRippleParams(event);
    onClick?.(event);
  };

  const slot = loader ? (
    <StyledLoaderWrapper>
      <Loader /> {loaderDesc ?? null}
    </StyledLoaderWrapper>
  ) : (
    children
  );

  return (
    <DefaultThemed>
      <StyledButton
        typeStyle={typeStyle || ButtonVariantsEnum.Primary}
        size={size || 'regular'}
        disabled={disabled || loader || false}
        sticky={sticky || false}
        {...clickPosition}
        {...restProps}
        onClick={handleClick}
        noMinWidth={noMinWidth}
        isFocused={isFocused || false}
      >
        {slot}
      </StyledButton>
    </DefaultThemed>
  );
};
